import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@mdi/font/css/materialdesignicons.css'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

const currentUrl = new URL(window.location.href);

if (currentUrl.searchParams.has('accesstoken') ||currentUrl.searchParams.has('refreshtoken'))
{
  currentUrl.searchParams.delete('accesstoken');
  currentUrl.searchParams.delete('refreshtoken');

  window.history.replaceState(
    window.history.state,
    '',
    currentUrl.pathname + currentUrl.search + currentUrl.hash
  );
}

Vue.use(Vuetify)
Vue.config.productionTip = false

new Vue({
  vuetify: new Vuetify(),
  router,
  store,
  render: h => h(App)
}).$mount('#app')
